export default {
    preloadImage: (src) => {
        return new Promise((resolve, reject) => {
            let image = new Image()

            image.onload = () => {
                resolve(image)
            }

            image.onerror = () => {
                reject()
            }

            image.src = src
        })
    },
    isEqual: (obj1, obj2) => {
        return JSON.stringify({ ...obj1 }) === JSON.stringify({ ...obj2 })
    },
    transformMap: (item, i, map) => {
        const itemProcessed = {
            ...item,
            id: i,
            imageId: item.image.split("/").pop(),
            image: null,
            parent: item.parent || 0,
            width: null,
            height: null,
            group: { id: map.id, name: map.name }
          };
  
          itemProcessed.objects = itemProcessed.objects.reduce((acc, item) => {
            if (item.type === "LEVEL" || item.type === "CAM") {
              return [...acc, item];
            } else {
              for (let i = 0; i < mapObjTypes.length; i++) {
                const webviewObjType = mapObjTypes[i];
                if (item.type.startsWith(webviewObjType)) {
                  return [
                    ...acc,
                    {
                      ...item,
                      type: webviewObjType,
                      status: webviewObjType
                    }
                  ];
                }
              }
            }
            return acc;
          }, []);

        return itemProcessed
    }
};


// WEBPACK FOOTER //
// ./src/common/helper.js